import { __awaiter, __generator } from "tslib";
var triggerHandler = null;
export var setTriggerReimburseHandler = function (fn) {
    triggerHandler = fn;
};
export var triggerReimburse = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!triggerHandler) {
                    throw new Error('AI 报销触发器尚未就绪');
                }
                return [4, triggerHandler(payload)];
            case 1: return [2, _a.sent()];
        }
    });
}); };
